import { useParams } from 'react-router-dom'
import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { getIdWithPrefix } from 'utils/pathUtils'
import { useGetHospital } from 'services/hospital'
import LoadingScreen from 'components/Layout/LoadingScreen'
import useDocumentTitle from 'components/useDocumentTitle'
import {
  MobileCompanyPageShell,
  MobileCompanyNotFound,
} from 'components/MobileCompanyPage/MobileCompanyPageShell'
import { buildHospitalPageContent } from './companyTypeData'

export function MobileHospitalPage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const hospitalID = urlParams?.hospital_id
    ? getIdWithPrefix(
        urlParams.hospital_id,
        preferences?.company_type_prefix_map[ContactCompanyType.Hospital]
      )
    : undefined

  const { data, isLoading } = useGetHospital(hospitalID)

  // Shared derivation — same stats/fields as the desktop NewHospitalPage.
  const content = buildHospitalPageContent(data)
  useDocumentTitle(isLoading ? 'Loading...' : content.documentTitle)

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!data || !content.contactCompanyId) {
    return <MobileCompanyNotFound label="Hospital not found" />
  }

  return (
    <MobileCompanyPageShell
      contactCompanyId={content.contactCompanyId}
      companyName={content.header.name}
      domain={content.header.domain}
      summaryContent={content.summaryContent}
      locationDetailsContent={content.locationDetailsContent}
    />
  )
}
